export default {
  // apiUrl: 'https://pwkp-cms.herokuapp.com',
  // apiUrl: 'http://localhost:1337', // for local development
  apiUrl:
    process.env.NODE_ENV === 'production'
      ? ''
      : 'https://pwkp.eu-4.evennode.com',
};
